module.exports = __webpack_public_path__ + "static/media/education.8fa695e9.svg";